module.exports = __webpack_public_path__ + "img/1524671090.27d6ff92.jpg";